import PlayButton from '../../../../assets/images/video-playbutton.png';
import { BaseProps } from '@mediashop/app/bloomreach/types';
import { injectComponent } from '@mediashop/app/component-injector';

function ProductDetailsPlayButton({ className }: BaseProps) {
    return <img alt="Video Image" src={PlayButton} className={className} />;
}

export default injectComponent('pattern.molecule.ProductDetailsPlayButton', ProductDetailsPlayButton, 'catalog-base');
